import { AbstractEntityMapper } from '@pf/shared-services';
import {
    PurchaseOrderLineCreate,
    PurchaseOrderLineDto,
    PurchaseOrderLineRead,
    PurchaseOrderLineSearchParams,
} from '../../entities/purchase-order-line.dto';
import { Injectable } from '@angular/core';
import { PlatformOrdersMapper } from '../platform-orders.mapper';
import { PurchaseOrderLineMetadataMap } from './purchase-order-line.mapping-profile';

@Injectable()
export class PurchaseOrderLineMapper extends AbstractEntityMapper<
    PurchaseOrderLineRead,
    PurchaseOrderLineCreate,
    PurchaseOrderLineDto,
    PurchaseOrderLineSearchParams
> {
    constructor() {
        super(
            PurchaseOrderLineDto,
            PlatformOrdersMapper,
            PurchaseOrderLineMetadataMap.symbols
        );
    }
}
